module.exports = __webpack_public_path__ + "static/media/minus-square.42e590f0.svg";